import { useCallback } from 'react';

import { useUserMenuDataShapes } from '../../../../controllers/user-state/user-menu-data-shapes-provider';

export function useNavItemVisibilityActions(itemMenuId: string) {
	const { userMenuData, visibleMenuIds, setUserMenuData } = useUserMenuDataShapes();

	const hideItem = useCallback(async () => {
		if (!visibleMenuIds.includes(itemMenuId)) {
			return;
		}

		const dataWithHiddenItem = userMenuData.map((datum) => {
			if (datum.menuId === itemMenuId) {
				return {
					...datum,
					visible: false,
				};
			}
			return datum;
		});

		setUserMenuData(dataWithHiddenItem);
	}, [itemMenuId, setUserMenuData, userMenuData, visibleMenuIds]);

	const showItem = useCallback(async () => {
		if (visibleMenuIds.includes(itemMenuId)) {
			return;
		}

		const dataWithVisibleItem = userMenuData.map((datum) => {
			if (datum.menuId === itemMenuId) {
				return {
					...datum,
					visible: true,
				};
			}
			return datum;
		});

		setUserMenuData(dataWithVisibleItem);
	}, [itemMenuId, setUserMenuData, userMenuData, visibleMenuIds]);

	return { hideItem, showItem };
}
